import { Model } from 'modules/core/lib/mobx-rest'

interface IPolicyAuthorization {
  [key: string]: any
}
class PolicyAuthorization extends Model<IPolicyAuthorization> {
  static urlRoot() {
    return '/permissions/permissions'
  }
}

export default PolicyAuthorization
